import { useState, lazy, Suspense } from "react";
import { CssBaseline, CircularProgress, Box } from "@mui/material/";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
// views
import CityScopeJS from "./views/CityScopeJS";
import WelcomeModal from "./Components/WelcomeModal";
// hooks

/**
get this tab URL and parse as a simple router to show the correct view
 **/

// El formulario de carga (Cognito + aws-amplify) se carga solo en /management,
// para no inflar el bundle del mapa.
const ManagementUpload = lazy(() => import("./views/ManagementUpload"));

const App = () => {
  const [showWelcomeModal, setShowWelcomeModal] = useState(true);

  const isManagement = window.location.pathname.startsWith("/management");

  if (isManagement) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Suspense
          fallback={
            <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <CircularProgress />
            </Box>
          }
        >
          <ManagementUpload />
        </Suspense>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <>
        <WelcomeModal
          isOpen={showWelcomeModal}
          onClose={() => setShowWelcomeModal(false)}
        />
        <CityScopeJS />
      </>
    </ThemeProvider>
  );
};

export default App;
